import { FINAL_STATUSES, GUEST_REQUEST_STATUSES, GUEST_REQUEST_TRANSITIONS, REVENUE_STATUSES, SEAT_HOLDING_STATUSES, } from "./types/guestRequest";
const EDGES = {
    accept: ["pending"],
    complete: ["accepted"],
    decline: ["pending"],
    cancel: ["pending", "accepted"],
    refund: ["accepted", "completed"],
};
const LANDS_ON = {
    accept: "accepted",
    complete: "completed",
    decline: "declined",
    cancel: "cancelled",
    refund: "refunded",
};
export function isGuestRequestStatus(v) {
    return (typeof v === "string" &&
        GUEST_REQUEST_STATUSES.includes(v));
}
export function isGuestRequestTransition(v) {
    return (typeof v === "string" &&
        GUEST_REQUEST_TRANSITIONS.includes(v));
}
export function guestRequestTransitionFrom(transition) {
    return EDGES[transition];
}
export function guestRequestTransitionTo(transition) {
    return LANDS_ON[transition];
}
export function nextGuestRequestStatus(from, transition) {
    return EDGES[transition].includes(from) ? LANDS_ON[transition] : null;
}
export function guestRequestIsFinal(status) {
    return FINAL_STATUSES.includes(status);
}
export function guestRequestHoldsSeat(status) {
    return SEAT_HOLDING_STATUSES.includes(status);
}
export function guestRequestIsRevenue(status) {
    return REVENUE_STATUSES.includes(status);
}
export function guestRequestIsAtRest(status) {
    return status !== "pending" && status !== "accepted";
}
export function guestMayCancel(status) {
    return status === "pending";
}
